var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5138 36.2771C47.5001 30.221 43.3902 24.512 37.3341 23.5257C31.278 22.5394 25.569 26.6493 24.5827 32.7054C23.5964 38.7615 27.7063 44.4705 33.7624 45.4567C39.8185 46.443 45.5275 42.3332 46.5138 36.2771Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7722 30.4418C37.345 26.9251 34.9584 23.6099 31.4417 23.0372C27.9249 22.4644 24.6098 24.851 24.037 28.3678C23.4643 31.8845 25.8509 35.1996 29.3676 35.7724C32.8843 36.3451 36.1995 33.9585 36.7722 30.4418Z",
    fill: "#0098C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0137 28.5498C29.5037 28.5498 29.0938 28.9598 29.0938 29.4698C29.0938 29.9798 29.5037 30.3898 30.0137 30.3898C30.5237 30.3898 30.9337 29.9798 30.9337 29.4698C30.9337 28.9598 30.5237 28.5498 30.0137 28.5498Z",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3228 36.0701C50.9928 34.0001 51.3528 31.7801 51.3528 29.4801C51.3528 17.6801 41.7928 8.12012 29.9928 8.12012C18.1928 8.12012 8.63281 17.6801 8.63281 29.4801C8.63281 30.3501 8.68281 31.2001 8.78281 32.0401",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1719 42.6396C17.0819 47.6296 23.1619 50.8396 30.0019 50.8396C34.5519 50.8396 38.7819 49.4096 42.2419 46.9896",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77312 29.54H1.45312",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4222 29.54H11.4922",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5445 29.54H54.2145H53.3745H47.1445",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9922 42.6104V52.9203V53.7104V58.0904",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9922 4.74V1",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9922 20.9004V11.6104",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9725 35.5703L13.4725 46.0703L12.8425 46.7003L9.8125 49.7303",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0117 20.5304L46.5217 13.0204L47.1217 12.4204L50.1817 9.36035",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6325 21.1804L13.4725 13.0204L12.8425 12.3904L9.8125 9.36035",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1834 49.7303L47.1234 46.6703L46.5234 46.0703L36.0234 35.5703",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5619 29.4704C38.5619 24.7404 34.7319 20.9004 29.9919 20.9004C25.2519 20.9004 21.4219 24.7404 21.4219 29.4704C21.4219 34.2004 25.2619 38.0404 29.9919 38.0404C32.3619 38.0404 34.5019 37.0804 36.0519 35.5304",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a2847238493f5b58c5c9fa83803ffff9.svg";
export { ForwardRef as ReactComponent };